import React, { Component } from "react";
import i18n from "../../i18n";
import { Translation } from "react-i18next";
import "../../assets/css/help.scoped.css";
import NavBar from "../NavBar";
import FooterSmall from "../FooterSmall";
import {
  getHelpDocsbyLanguage
} from  "../../utils/helpUrls";


export class VideoTutorialEmbed extends Component {
  constructor(props) {
    super(props)
    this.language=i18n.language;
  }

  render() {
    const language = this.language;
    const { faqPath, videoTutorialPath } = getHelpDocsbyLanguage(language);
      return (
      <>
      <style>
        {`
          body {
            /*height: 100vh;*/
          }
        `}
      </style>
      <div style={{
        position: 'absolute', 
        top:0,
        position: 'absolute',
        top: '0px',
        width: '100%',
        marginBottom: '0px'
      }}>
      <NavBar />
      </div>
      <div style={{ marginTop: '20px',
          marginTop: '47px',
          maxHeight: '80vh',
          overflowY: 'auto'
       }}>
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <iframe
            src={videoTutorialPath}
            // "Update the support ticket page too, let me know what you guys think. Use a little chatGPT help by back and forth prompting to make the text fun embedding some analogy with music and dance there. 🙂 When chatGPT finally got it right, I said great! He/she even give me a smiley face emoji back! 😛 https://docs.google.com/forms/d/e/1FAIpQLScxZpR8Vz892hOZ_1R1HaO82LAp24sdcEWgoUzjYfO74DTfPQ/viewform?usp=header"
            width="100%" 
            height="1285" 
            frameborder="0"
             margin="0 auto" 
             marginheight="0"
             marginwidth="0"
             >
            Loading…</iframe>
        </div>
      </div>
        <div 
        style={{
          position: 'relative',
          marginTop: '10%'
        }}
        >
        <FooterSmall />
        </div>
      </>
    )
  }
}

